export const DISPLAY_NOTIFICATION = Symbol();
